import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const WarningIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M22.239 18.451L13.442 3.816C13.135 3.305 12.596 3 12 3C11.404 3 10.865 3.305 10.559 3.815L1.76101 18.451C1.44901 18.97 1.44101 19.619 1.73901 20.146C2.03601 20.673 2.59701 21 3.20301 21H20.798C21.403 21 21.965 20.673 22.262 20.146C22.56 19.619 22.551 18.97 22.239 18.451ZM12.5 18H11.5C11.224 18 11 17.776 11 17.5V16.5C11 16.224 11.224 16 11.5 16H12.5C12.776 16 13 16.224 13 16.5V17.5C13 17.776 12.776 18 12.5 18ZM12 14C11.448 14 11 13.552 11 13V10C11 9.448 11.448 9 12 9C12.552 9 13 9.448 13 10V13C13 13.552 12.552 14 12 14Z"
      fill={props.sx?.color || '#FFA10A'}
    />
  </SvgIcon>
);

WarningIcon.propTypes = {
  sx: PropTypes.object,
};

export default WarningIcon;
